import * as React from 'react';
import { MarketTrendsTitle } from '../../components/MarketTrendsTitle';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { PriceDynamicsContainer } from '../PriceDynamicsContainer';
import { useSelector } from 'react-redux';
import { TRefWrapper } from '../Scrolling';
import { trackOnTitleTooltipOpen } from './utils/tracking';
import { selectNearbyHousesInfo } from '../../selectors/nearbyHousesInfo/nearbyHousesInfoSelectors';
import { SupplyDemandContainer } from '../SupplyDemandContainer';
import { MarketTrendsWrapper } from '../../components/MarketTrendsWrapper';
import { MarketTrendsSpinner } from '../../components/MarketTrendsSpinner';
import { selectDealType } from '../../selectors/page';
import { EDealType } from '../../types/dealType';
import { selectAvailableFilters, selectIsAvailableFiltersLoading } from '../../selectors/marketTrend';

interface IMarketTrendsContainerParams {
  refWrapper: TRefWrapper;
}

export function MarketTrendsContainer({ refWrapper }: IMarketTrendsContainerParams) {
  const isDesktop = useIsDesktop();

  const dealType = useSelector(selectDealType);
  const tooltipInfo = useSelector(selectNearbyHousesInfo);
  const isLoading = useSelector(selectIsAvailableFiltersLoading);
  const { supplyDemandShow, ...rest } = useSelector(selectAvailableFilters);

  const showPriceDynamic = Object.values(rest).find(item => item === true);

  const onTooltipOpen = React.useCallback(() => {
    trackOnTitleTooltipOpen();
  }, []);

  if (isLoading) {
    return <MarketTrendsSpinner isDesktop={isDesktop} />;
  }

  if ((!showPriceDynamic && !supplyDemandShow) || dealType === EDealType.Rent) {
    return null;
  }

  return (
    <MarketTrendsWrapper refWrapper={refWrapper}>
      <MarketTrendsTitle isDesktop={isDesktop} onTooltipOpen={onTooltipOpen} tooltipInfo={tooltipInfo} />
      {showPriceDynamic && <PriceDynamicsContainer />}
      {supplyDemandShow && <SupplyDemandContainer />}
    </MarketTrendsWrapper>
  );
}
